import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { BusService } from "../bus.service";
import {
  IPostOptions,
  RequestService
} from "../request.service";
import { EventsService } from "../events.service";

interface IPostCredentialsRequest {
  picture: any;
}

interface IPostCredentialsResponse {
}

/*
  An interlayer service for authentication between request service and login component
*/
@Injectable()
export class ProfilePictureService {

  private options: IPostOptions<IPostCredentialsRequest, IPostCredentialsResponse>;

  constructor(
    private bus: BusService,
    private events: EventsService,
    private requestService: RequestService
  ) {
    this.options = {
      uri: "/profile-picture",
      body: {
        picture: ""
      },
      handlers: {
        success: this.success.bind(this),
        error: this.error.bind(this)
      }
    };
    this.subscribe();
  }

  public success(user: IPostCredentialsResponse): void {
    this.bus.publish(this.events.received.data.settings.profilePicture.success, user);
  }

  public error(httpErrorResponse: HttpErrorResponse): void {
    this.bus.publish(this.events.received.data.settings.profilePicture.failure, httpErrorResponse);
  }

  private request(data: any): void {
    // this.bus.publish(this.events.notified.request.starting);
    this.options.body.picture = data.picture;
    // this.requestService.post<IPostCredentialsRequest, IPostCredentialsResponse>(this.options);
  }

  public subscribe(): void {
    this.bus.subscribe(this.events.requested.data.settings.profilePicture, this.request.bind(this));
  }
}
